import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import Anexos from '../../../../components/auth/licitacao/listar/form_arquivo'


function AnexosLicScreen() {

    return (
        <Fragment>
            <Head titulo="Anexando arquivos - Módulo Licitações" />
            <HeaderLogged />
            <Container>
               <Anexos />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default AnexosLicScreen;